<template>
  <PageContent id="faqs">
    <template slot="heading-title">Frequently Asked Questions</template>
    <div class="container" slot="content">
      <FaqContent/>
    </div>
  </PageContent>
</template>

<script>
import Menu from '@/components/custom/Menu';
import CustomMap from '@/components/custom/CustomMap';
import PageContent from '@/components/abstract/PageContent';
import {mapGetters, mapActions} from 'vuex';
import BackToTop from '@/components/custom/BackToTop';
import Accordion from '@/components/custom/Accordion';
import {FAQS} from '@/enum/screens.enum';
import FaqContent from '@/components/pages/FaqContent';

export default {
  data() {
    return {
      faqState: []
    }
  },
  components: {Menu, CustomMap, PageContent, BackToTop, Accordion, FaqContent},
  computed: {
    ...mapGetters('map', ['faq'])
  },
  watch: {
    'faq': {
      handler: function () {
        this.faqState = this.faq.map((item) => ({
          id: item.weight,
          active: false,
          title: item.question,
          details: item.answer
        }))
      }
    }
  },
  methods: {
    ...mapActions('map', ['loadFaq', 'screenVisited'])
  },
  mounted() {
    this.loadFaq();
    this.screenVisited({ screen: FAQS });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import 'nib'

.container
  width 1200px
  margin 40px auto
  max-width 100%
  background #FFFFFF
  border 1px solid #dadada
  relative top left
  box-sizing border-box
  @media screen and (max-width 768px)
    padding 15px
    padding-bottom 65px

</style>



// WEBPACK FOOTER //
// src/components/pages/Faq.vue